<style lang="scss">
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/utils";

  .progress-bar {
    margin-top: utils.in_rem(16px);
    height: utils.in_rem(4px);
    border-radius: 2px;
    background-color: colors.get(interfaceSwGrey_10);

    .progress {
      height: 100%;
      background-color: colors.get(primary_60);
      border-radius: 2px;
      transition: width 0.2s;
    }
  }

  .error-message {
    color: colors.get(systemError_100);
    font-size: utils.in_rem(14px);
    margin-top: utils.in_rem(8px);
  }
</style>

<script>
  export let progress = 0;
  export let errorMessage = "";
</script>

<div class="progress-bar">
  <div class="progress" style="width: {progress}%"></div>
</div>

{#if errorMessage}
  <div class="error-message">{errorMessage}</div>
{/if}
